<template>
    <div class="af-app af-login-widget">
        <LoggedIn v-if="showLoggedIn" />
        <LoggedOut v-if="showLoggedOut" />
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import Cookie from '@/services/cookie';
    import LoggedIn from '@/apps/login-widget/001/components/LoggedIn';
    import LoggedOut from '@/apps/login-widget/001/components/LoggedOut';

    export default {
        name: 'App',

        components: {
            LoggedIn,
            LoggedOut,
        },

        data() {
            return {
                showLoggedIn: false,
                showLoggedOut: false,
            };
        },

        async created() {
            if (Cookie.getToken()) {
                await this.$_authenticated();
            }

            const token = Cookie.getToken();
            this.showLoggedIn = !!token;
            this.showLoggedOut = !token;
        },

        methods: {
            ...mapActions('me', {
                $_authenticated: 'authenticated',
            }),
        },
    };
</script>
